var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImported(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "l1owiyskta",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FF7E5D",
    xlinkHref: "#l1owiyskta"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F7F8F9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.38 4.506v.803c0 .382-.309.691-.69.691-.38 0-.69-.309-.69-.69V2.69c0-.109.026-.216.074-.312l-.157-.163c-.253-.263-.267-.707-.033-.992.236-.282.63-.3.883-.036l.31.324c.153.172.297.35.433.535l1.84.107c.38.022.672.348.649.73-.023.38-.326.675-.73.647l-.933-.054c.436.992.664 2.086.664 3.218 0 1.953-.677 3.786-1.906 5.167C10.906 13.2 9.323 13.957 7.638 14h-.014c-.339 0-.616-.306-.624-.687-.007-.386.266-.706.61-.715 1.36-.034 2.64-.647 3.601-1.729.994-1.114 1.54-2.597 1.54-4.175 0-.762-.127-1.502-.371-2.188zM2.186 11.554C.403 8.688.632 4.694 2.862 2.14 4.068.759 5.667 0 7.37 0c.378.015.632.308.631.703-.001.387-.275.698-.611.698h-.02c-1.375 0-2.668.614-3.641 1.73-1.525 1.747-1.892 4.326-1.103 6.474.042-.34.333-.605.685-.605.38 0 .69.309.69.69v2.08l.013.013c.248.263.264.707.036.992-.122.148-.286.225-.451.225-.046 0-.09-.006-.135-.017-.05.011-.101.017-.153.017-.013 0-.028 0-.04-.002l-2.62-.152c-.38-.022-.672-.349-.649-.73.023-.38.327-.668.73-.648l1.455.086z",
    transform: "translate(5 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImported);
export default __webpack_public_path__ + "static/media/imported.6db1be0198add529aeef0a09f1ab273e.svg";
export { ForwardRef as ReactComponent };